import * as React from 'react';
import { SVGProps } from 'react';

const AccountGirl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width="500"
    height="500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 500 500"
    {...props}
  >
    <defs>
      <clipPath id="clippath">
        <path
          d="m171.88,143.96c-1.26.16-2.03,1.47-1.54,2.64,3.16,7.56,11.61,12.37,20.79,11.22,9.19-1.16,16.18-7.92,17.36-16.03.18-1.25-.89-2.33-2.15-2.17l-34.47,4.35Z"
          style={{ fill: '#7f1917' }}
        />
      </clipPath>
    </defs>
    <g>
      <path
        d="m201.45,219.53s-.06,0-.1,0c-34.34-.28-61.88-11.98-84.19-35.75-4.29-4.57-4.06-11.75.51-16.04,4.57-4.29,11.75-4.06,16.04.51,18.08,19.27,39.64,28.35,67.83,28.58,6.27.05,11.31,5.17,11.25,11.44-.05,6.24-5.12,11.26-11.35,11.26Z"
        style={{ fill: '#f2f2f2' }}
      />
      <path
        d="m154.58,210.39l-.66-.28c-1.64-.71-3.23-1.45-4.77-2.22l10.09-20.33c1.21.6,2.45,1.18,3.7,1.72l.62.27-8.98,20.85Z"
        style={{ fill: '#f59220' }}
      />
      <g style={{ opacity: '.1' }}>
        <path d="m201.93,215.86c-38.1-1.1-61.59-12.5-83.9-36.27-2.75-2.93-3.59-4.75-2.67-8.38-1.92,4.09-1.41,9.16,1.87,12.66,22.31,23.77,49.96,35.4,84.3,35.68h.1c5.29,0,9.74-3.64,10.99-8.56-1.81,3.86-10.65,4.88-10.68,4.87Z" />
      </g>
      <path
        d="m273.81,158.57c.99-.36,2.11.23,2.51,1.32l39.09,106.42c.4,1.09-.07,2.27-1.06,2.63l-74.93,27.53c-3.57,1.31-7.75-1.13-9.34-5.46l-34.79-94.71c-1.59-4.32.02-8.89,3.58-10.2l74.93-27.53Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m262.39,162.76l40.55,110.38-68.21,25.06c-.97.36-2.08-.24-2.48-1.33l-39.09-106.42c-.4-1.09.06-2.27,1.03-2.62l62.78-23.06s4.21-1.55,5.43-2Z"
        style={{ fill: '#c7962e' }}
      />
      <g style={{ opacity: '.1' }}>
        <path d="m262.39,162.76l40.55,110.38-68.21,25.06c-.97.36-2.08-.24-2.48-1.33l-39.09-106.42c-.4-1.09.06-2.27,1.03-2.62l62.78-23.06s4.21-1.55,5.43-2Z" />
      </g>
      <path
        d="m293.39,387.84c-2.67,0-5.36-.8-7.69-2.47-17.44-12.48-41.52-38.39-57.14-91-2.08-7.01,1.91-14.38,8.92-16.46,7-2.08,14.38,1.91,16.46,8.92,6.09,20.52,20.33,57.81,47.16,77,5.95,4.25,7.32,12.52,3.07,18.47-2.58,3.61-6.65,5.54-10.78,5.54Z"
        style={{ fill: '#f0f0f0' }}
      />
      <path
        d="m249.72,344.34c-1.19-2.03-2.38-4.15-3.52-6.29l23.35-12.5c.99,1.84,2,3.66,3.02,5.39l-22.85,13.39Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m323.54,378.04l-23.04-14.65-14.21,22.37,10.55,6.71-3.34,5.19c-4.58,7.21-3.08,16.55,3.16,22,1.03.9,2.63.7,3.36-.46l24.21-38.09c.66-1.03.35-2.4-.68-3.06Z"
        style={{ fill: '#f59220' }}
      />
      <g id="Neck">
        <path
          d="m199.19,165.2l8.74,23.78.09-.03c-.02-.06,21.84-8.1,21.86-8.03l.09-.03-8.74-23.78-22.05,8.1Z"
          style={{ fill: '#e9cbc2' }}
        />
      </g>
      <g style={{ opacity: '.1' }}>
        <path
          d="m223.24,162.5l-5.54,2.03,8.72,23.74c3.13-1.14,5.45-1.98,5.46-1.96l.09-.03-8.74-23.78Z"
          style={{ fill: '#723e32' }}
        />
      </g>
      <circle cx="119.1" cy="107.93" r="8.59" style={{ fill: '#c7962e' }} />
      <path
        d="m170.03,27.58c1.29-.55,2.6-1.07,3.94-1.56,42.03-15.44,88.61,6.12,104.05,48.14,14.95,40.69-4.79,85.66-44.2,102.49-1.29.55-2.6,1.07-3.94,1.56-42.03,15.44-88.61-6.12-104.05-48.14-14.95-40.69,4.79-85.66,44.2-102.49m-1.49-3.49c-41.54,17.73-61.87,64.86-46.28,107.29,16.14,43.93,63.84,66.35,108.68,50,1.38-.51,2.77-1.06,4.12-1.63,42.48-17.45,62.11-64.46,46.52-106.89-7.82-21.28-23.45-38.24-44.03-47.76-20.57-9.52-43.62-10.46-64.9-2.64-1.38.51-2.77,1.06-4.12,1.63h0Z"
        style={{ fill: '#f59220' }}
      />
      <g style={{ opacity: '.2' }}>
        <path
          d="m250.87,57.12c-1-1.67-5.1-5.94-6.24-6.75-1.7-.94-2.37-3.07-1.5-4.83.9-1.81,3.1-2.55,4.91-1.65,2.2,1.1,7.71,7.14,9.11,9.46,1.04,1.73.48,3.98-1.25,5.03-.27.16-.56.29-.85.37-1.56.46-3.3-.17-4.18-1.63Zm-6.1-6.68l-.1-.05s.07.04.1.05Z"
          style={{ fill: '#fff' }}
        />
      </g>
      <g style={{ opacity: '.2' }}>
        <path
          d="m239.01,45.8c.74-.22,1.42-.67,1.91-1.34,1.2-1.63.85-3.92-.78-5.12-8.13-5.97-17.54-9.72-27.98-11.12-2-.27-3.85,1.14-4.12,3.14-.27,2.01,1.14,3.85,3.14,4.12,9.21,1.24,17.49,4.53,24.62,9.77.96.7,2.15.87,3.21.56Z"
          style={{ fill: '#fff' }}
        />
      </g>
      <g>
        <path
          d="m143.54,102.81l5.39,48.39c1.37,12.27,12.87,21.06,25.7,19.63l69-7.68c12.83-1.43,22.12-12.53,20.75-24.81l-5.4-48.48-115.44,12.95Z"
          style={{ fill: '#7f2919' }}
        />
        <path
          d="m235.11,127.24c1,8.68,8.85,14.91,17.53,13.91,8.68-1,14.91-8.85,13.91-17.53-1-8.68-8.85-14.91-17.53-13.91h0c-8.68,1-14.91,8.85-13.91,17.53"
          style={{ fill: '#f4d8ce' }}
        />
        <path
          d="m205.5,174.8l3.08-.35c25.41-2.99,43.69-25.46,40.9-50.3l-3.65-31.68c-2.93-24.8-25.83-42.53-51.24-39.67l-3.1.36c-25.4,3-43.66,25.46-40.87,50.28l3.65,31.68c2.93,24.81,25.82,42.54,51.24,39.68"
          style={{ fill: '#f4d8ce' }}
        />
        <path
          d="m173.75,117.58c.52-.06.89-.54.83-1.06-.04-.34-.26-.63-.58-.77-3.02-1.22-6.46-.82-9.13,1.05-.43.3-.54.89-.24,1.32.3.43.89.54,1.32.24,2.14-1.51,4.9-1.82,7.33-.84.14.06.3.08.46.06Z"
          style={{ fill: '#7f2919' }}
        />
        <path
          d="m208.33,114.7c.53-.04.92-.49.89-1.02-.02-.34-.23-.65-.54-.8-2.95-1.38-6.41-1.16-9.17.56-.45.28-.58.86-.31,1.31.28.45.86.58,1.31.31,2.22-1.39,4.99-1.56,7.37-.45.14.06.3.09.45.09Z"
          style={{ fill: '#7f2919' }}
        />
        <path d="m165.17,126.34c.34,2.93,3,5.04,5.93,4.7,2.93-.34,5.04-3,4.7-5.93-.34-2.93-2.99-5.03-5.93-4.7-2.94.34-5.04,2.99-4.7,5.93h0" />
        <path d="m199.7,122.49c.34,2.93,3,5.04,5.93,4.7,2.93-.34,5.04-3,4.7-5.93-.34-2.93-2.99-5.03-5.93-4.7-2.94.34-5.04,2.99-4.7,5.93h0" />
        <g id="Nose">
          <rect
            x="181.33"
            y="129.16"
            width="11.47"
            height="7.11"
            rx="2.5"
            ry="2.5"
            transform="translate(-13.96 22.28) rotate(-6.57)"
            style={{ fill: '#c1b49a' }}
          />
        </g>
        <path
          d="m245.5,91.3c-2.8-23.9-23.57-41.29-49.5-38.25l-3.15.37c-25.93,3.04-44.99,25.58-42.19,49.49,0,0,3.42,30.71,3.47,31.06-7.71-8.2-9.21-19.47-10.58-31.17-3.62-30.92,17.35-58.19,50.89-62.12,33.54-3.93,60.99,18.25,64.55,49.18,1.86,16.21-9.53,34.05-9.73,32.34l-3.76-30.9Z"
          style={{ fill: '#7f2919' }}
        />
        <path
          d="m169.33,52.97c3.39-2.2,7.07-4.02,10.99-5.38,3.64-1.28,7.48-2.17,11.47-2.61l3.37-.37c27.79-3.09,58.18,26.15,53.38,55,0,0-6.49.78-10.54,1.17-15.78,1.52-20.82-5.68-31.12-21.3-6.11,18.29-20.98,27.16-39.45,29.21-15.68,1.75-19.79-2.99-20.01-5.01l-.18-1.61c-2.11-18.92,6.83-39.15,22.1-49.1Z"
          style={{ fill: '#7f2919' }}
        />
        <g style={{ opacity: '.1' }}>
          <path
            d="m252.63,141.15c-1.54.18-3.05.12-4.51-.13-4.84,17.44-20.1,31.16-39.55,33.44,33.77-12.89,37.79-41.46,33.99-74.16,1.53-.17,3-.34,4.1-.47l1.17,10.1c.38-.08.77-.16,1.18-.2,8.67-1,16.52,5.23,17.53,13.91,1,8.69-5.23,16.53-13.91,17.53Z"
            style={{ fill: '#723e32' }}
          />
        </g>
        <g>
          <path
            d="m171.88,143.96c-1.26.16-2.03,1.47-1.54,2.64,3.16,7.56,11.61,12.37,20.79,11.22,9.19-1.16,16.18-7.92,17.36-16.03.18-1.25-.89-2.33-2.15-2.17l-34.47,4.35Z"
            style={{ fill: '#fff' }}
          />
          <g>
            <path
              d="m171.88,143.96c-1.26.16-2.03,1.47-1.54,2.64,3.16,7.56,11.61,12.37,20.79,11.22,9.19-1.16,16.18-7.92,17.36-16.03.18-1.25-.89-2.33-2.15-2.17l-34.47,4.35Z"
              style={{ fill: '#7f1917' }}
            />
            <g style={{ clipPath: 'url(#clippath)' }}>
              <path
                d="m204.76,143.2l-30.48,3.84c-.81.1-1.57-.41-1.78-1.19l-1-3.7,34.75-4.38-.05,3.83c-.01.82-.62,1.5-1.43,1.6Z"
                style={{ fill: '#fff' }}
              />
              <ellipse
                cx="191.84"
                cy="163.43"
                rx="11.55"
                ry="10.62"
                transform="translate(-18.95 25.3) rotate(-7.19)"
                style={{ fill: '#d57e79' }}
              />
            </g>
          </g>
        </g>
      </g>
      <g style={{ opacity: '.3' }}>
        <circle cx="201.93" cy="102.13" r="81.07" style={{ fill: '#fff' }} />
      </g>
      <circle cx="285.18" cy="101.96" r="10" style={{ fill: '#f59220' }} />
      <path
        d="m192.15,196.3l62.56-23.03-1.78-4.85c-.44-1.21-1.79-1.83-3-1.39l-58.29,21.43c-1.21.44-1.83,1.79-1.39,3l1.89,4.85Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m192.15,196.3l33.53,91.28c6.29,17.11,25.27,25.87,42.37,19.54.25-.09.51-.19.76-.28,17.04-6.31,25.77-25.21,19.5-42.27-13.3-36.19-33.54-91.28-33.54-91.28-1.06.39-60.75,22.31-62.62,23Z"
        style={{ fill: '#f0f0f0' }}
      />
      <polygon
        points="212.32 221.35 219.69 218.69 213.37 212.94 212.32 221.35"
        style={{ fill: '#de3735' }}
      />
      <path
        d="m244.81,219.07h0c1.65-.6,3.55.41,4.23,2.24h0c.69,1.84-.1,3.81-1.75,4.4-1.66.6-3.55-.41-4.24-2.24-.69-1.84.1-3.81,1.75-4.4m-.77-2.06h0c-2.68.97-3.94,4.17-2.83,7.14h0c1.11,2.97,4.19,4.6,6.87,3.63,2.68-.97,3.95-4.17,2.84-7.14-1.11-2.97-4.19-4.59-6.87-3.63h0Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m249.51,231.67c1.66-.6,3.55.41,4.24,2.25h0c.68,1.84-.11,3.81-1.76,4.41-1.66.59-3.56-.41-4.24-2.25-.68-1.84.11-3.81,1.76-4.41m-.77-2.06h0c-2.68.97-3.95,4.17-2.83,7.14h0c1.11,2.97,4.19,4.6,6.87,3.63,2.68-.97,3.95-4.17,2.84-7.14-1.11-2.97-4.19-4.59-6.87-3.63h0Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m219.08,228.22c1.65-.6,3.55.41,4.23,2.24h0c.68,1.83-.1,3.8-1.76,4.4-1.66.6-3.55-.41-4.24-2.24-.69-1.84.1-3.81,1.75-4.4m-3.59,5.07v.03c1.13,2.97,4.21,4.58,6.88,3.6s3.93-4.18,2.81-7.15c-1.12-2.97-4.2-4.58-6.87-3.6-2.67.98-3.93,4.16-2.82,7.12Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m223.79,240.82c1.65-.6,3.55.41,4.24,2.24h0c.68,1.84-.11,3.81-1.76,4.41-1.66.59-3.55-.41-4.24-2.25-.68-1.84.11-3.81,1.76-4.41m-.77-2.06c-2.67.98-3.93,4.16-2.82,7.13v.03c1.13,2.97,4.21,4.58,6.88,3.6,2.67-.98,3.93-4.18,2.81-7.15-1.12-2.97-4.2-4.58-6.87-3.6h0Z"
        style={{ fill: '#f59220' }}
      />
      <ellipse
        cx="236.59"
        cy="198.67"
        rx="3.14"
        ry="3.49"
        transform="translate(-59 108.84) rotate(-23.12)"
        style={{ fill: '#f59220' }}
      />
      <ellipse
        cx="240.05"
        cy="207.92"
        rx="3.14"
        ry="3.49"
        transform="translate(-62.36 110.94) rotate(-23.12)"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m238.7,191.61l-34.25,12.34c-1.4.5-2.14,1.89-1.69,3.11l6.01,16.1c.45,1.22,1.94,1.81,3.34,1.3l34.25-12.34c1.4-.5,2.14-1.9,1.69-3.12l-6.01-16.11c-.45-1.22-1.94-1.8-3.34-1.3h0Zm-25.98,34.49c-2.42.87-5.03-.14-5.82-2.25l-6.01-16.1c-.79-2.13.51-4.56,2.95-5.44l34.25-12.34c2.42-.87,5.04.15,5.83,2.27l6,16.08c.8,2.13-.51,4.57-2.95,5.45l-34.25,12.34h0Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m333.31,365.87c-2.09,0-4.22-.5-6.2-1.55-27.47-14.58-48.29-43.43-61.88-85.75-2.24-6.96,1.59-14.42,8.56-16.66,6.96-2.24,14.42,1.59,16.66,8.56,11.41,35.52,27.93,59.23,49.09,70.46,6.46,3.43,8.92,11.44,5.49,17.9-2.38,4.48-6.96,7.04-11.71,7.04Z"
        style={{ fill: '#f0f0f0' }}
      />
      <path
        d="m286.04,324.6c-1.04-1.65-2.08-3.36-3.09-5.1l22.91-13.29c.84,1.45,1.7,2.87,2.56,4.23l-22.38,14.16Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m363.72,352.81l-24.56-12.07-11.7,23.83,11.24,5.52-2.76,5.53c-3.78,7.68-1.26,16.82,5.56,21.57,1.13.79,2.69.41,3.3-.83l19.94-40.59c.54-1.1.09-2.43-1.01-2.97Z"
        style={{ fill: '#f59220' }}
      />
      <path
        d="m224.46,284.61l62.71-23.11-3.63-9.88-62.7,23.12c.92,2.54,1.84,5.02,2.71,7.42.15.42.3.82.44,1.23.16.41.3.82.46,1.22Z"
        style={{ fill: '#f59220' }}
      />
      <rect
        x="236.93"
        y="263.51"
        width="15.8"
        height="15.52"
        rx="3.82"
        ry="3.82"
        transform="translate(568.19 441.49) rotate(159.83)"
        style={{ fill: '#c7962e' }}
      />
      <g style={{ opacity: '.1' }}>
        <path d="m287.18,261.5l-30.38-82.69c-4.49,3.49-7.5,9.25-7.96,11.84,1.32,6.18,22.29,65.87,35.35,98.67,16.45,41.31,45.65,61.48,77.24,73.01l3.32-6.81c.6-1.36-.12-2.55-1.01-2.97-9.54-4.57-16.02-7.51-24.79-12.16-19.52-10.34-33.29-32.66-41.06-49.88-3.42-7.57-8.96-24.83-10.7-29.02Z" />
      </g>
      <g>
        <rect
          x="304.75"
          y="255.98"
          width="8.11"
          height="18.24"
          rx="3.25"
          ry="3.25"
          transform="translate(698.99 380.82) rotate(155.87)"
          style={{ fill: '#e6e6e6' }}
        />
        <rect
          x="309.26"
          y="261.72"
          width="8.11"
          height="13.52"
          rx="2.84"
          ry="2.84"
          transform="translate(430.27 -127.21) rotate(65.87)"
          style={{ fill: '#e6e6e6' }}
        />
        <rect
          x="303.53"
          y="242.79"
          width="27.32"
          height="26.3"
          rx="8.04"
          ry="8.04"
          transform="translate(712.64 157.3) rotate(127.09)"
          style={{ fill: '#f0f0f0' }}
        />
        <rect
          x="326.59"
          y="244.69"
          width="6.66"
          height="15.86"
          rx="2.55"
          ry="2.55"
          transform="translate(-70.57 363.43) rotate(-52.91)"
          style={{ fill: '#f0f0f0' }}
        />
        <rect
          x="322.24"
          y="250.15"
          width="7.08"
          height="15.86"
          rx="2.63"
          ry="2.63"
          transform="translate(-76.56 362.3) rotate(-52.91)"
          style={{ fill: '#f0f0f0' }}
        />
        <rect
          x="318.22"
          y="255.36"
          width="6.95"
          height="16.25"
          rx="2.67"
          ry="2.67"
          transform="translate(-82.49 361.18) rotate(-52.91)"
          style={{ fill: '#f0f0f0' }}
        />
        <rect
          x="314.02"
          y="260.93"
          width="6.95"
          height="16.25"
          rx="2.67"
          ry="2.67"
          transform="translate(-88.61 360.04) rotate(-52.91)"
          style={{ fill: '#f0f0f0' }}
        />
      </g>
      <path
        d="m308.74,260.98c-2.64,0-5.29-.92-7.44-2.78-15.06-13.08-44.06-48.02-53.28-69.47-2.47-5.76.19-12.43,5.95-14.91,5.76-2.47,12.43.19,14.91,5.95,7.51,17.47,34.4,50.08,47.31,61.3,4.73,4.11,5.23,11.28,1.12,16.01-2.24,2.58-5.4,3.91-8.57,3.91Z"
        style={{ fill: '#f0f0f0' }}
      />
      <path
        d="m273.79,228.26c-1.16-1.45-2.3-2.91-3.44-4.38l17.97-13.86c1.06,1.38,2.13,2.74,3.21,4.1l-17.75,14.15Z"
        style={{ fill: '#f59220' }}
      />
      <g>
        <rect
          x="104.89"
          y="154.36"
          width="27.46"
          height="26.44"
          rx="8.08"
          ry="8.08"
          transform="translate(-79.58 114.02) rotate(-39.59)"
          style={{ fill: '#f2f2f2' }}
        />
        <path
          d="m128.06,151.53l-1.62.31c-1.76.34-2.92,2.05-2.58,3.8l1.36,7.12c-3.46,3.75,1.33,10.42,6.82,6.94,1.51-.96,2.36-2.34,2.02-4.1l-2.19-11.49c-.34-1.76-2.05-2.92-3.8-2.58Z"
          style={{ fill: '#fff' }}
        />
        <rect
          x="121.24"
          y="149.41"
          width="8.15"
          height="13.6"
          rx="2.86"
          ry="2.86"
          transform="translate(-4.62 308.58) rotate(-100.81)"
          style={{ fill: '#fff' }}
        />
        <g style={{ opacity: '.1' }}>
          <path d="m110.44,174.61c2.26,2.98,5.23,6.52,10.4,7.91-3.44,1.56-7.47.36-9.59-2.23l-6.54-7.91c-1.93-2.33-2.33-5.45-1.29-8.1,0,0,5.51,8.34,7.02,10.33Z" />
        </g>
        <rect
          x="102.05"
          y="159.9"
          width="6.7"
          height="15.95"
          rx="2.57"
          ry="2.57"
          transform="translate(293.6 230.08) rotate(140.41)"
          style={{ fill: '#fff' }}
        />
        <rect
          x="107.15"
          y="155.52"
          width="7.12"
          height="15.95"
          rx="2.65"
          ry="2.65"
          transform="translate(300.21 218.94) rotate(140.41)"
          style={{ fill: '#fff' }}
        />
        <rect
          x="112.46"
          y="150.99"
          width="6.99"
          height="16.33"
          rx="2.68"
          ry="2.68"
          transform="translate(306.74 207.93) rotate(140.41)"
          style={{ fill: '#fff' }}
        />
        <rect
          x="117.87"
          y="146.51"
          width="6.99"
          height="16.33"
          rx="2.68"
          ry="2.68"
          transform="translate(313.45 196.54) rotate(140.41)"
          style={{ fill: '#fff' }}
        />
      </g>
    </g>
    <path
      d="m191.96,352.81c-.99,0-1.93-.59-2.32-1.57l-10.32-25.66c-.52-1.28.11-2.74,1.39-3.25,1.28-.52,2.74.1,3.25,1.39l10.32,25.66c.52,1.28-.11,2.74-1.39,3.25-.31.12-.62.18-.93.18Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m174.5,309.38c-.99,0-1.93-.59-2.32-1.57l-28.45-70.76c-.52-1.28.11-2.74,1.39-3.25,1.28-.52,2.74.1,3.25,1.39l28.45,70.76c.52,1.28-.11,2.74-1.39,3.25-.31.12-.62.18-.93.18Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m258.66,442.01c-.95,0-1.87-.55-2.28-1.48l-33.69-75.07c-.56-1.26,0-2.74,1.26-3.3,1.26-.56,2.74,0,3.3,1.26l33.69,75.07c.56,1.26,0,2.74-1.26,3.3-.33.15-.68.22-1.02.22Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m385.28,481.65c-.98,0-1.92-.58-2.31-1.55l-18.01-43.74c-.53-1.28.08-2.74,1.36-3.26,1.28-.52,2.74.08,3.26,1.36l18.01,43.74c.53,1.28-.08,2.74-1.36,3.26-.31.13-.63.19-.95.19Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m363.26,428.17c-.98,0-1.92-.58-2.31-1.55l-6.07-14.75c-.53-1.28.08-2.74,1.36-3.26,1.28-.53,2.74.08,3.26,1.36l6.07,14.75c.53,1.28-.08,2.74-1.36,3.26-.31.13-.63.19-.95.19Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m316.2,186.65c-.97,0-1.89-.57-2.3-1.51l-19.65-45.73c-.54-1.27.04-2.74,1.31-3.28,1.27-.54,2.74.04,3.28,1.31l19.65,45.73c.54,1.27-.04,2.74-1.31,3.28-.32.14-.66.2-.99.2Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m325.83,209.65c-.97,0-1.89-.57-2.3-1.52l-5.28-12.32c-.54-1.27.04-2.74,1.31-3.28,1.27-.54,2.74.04,3.28,1.31l5.28,12.32c.54,1.27-.04,2.74-1.31,3.28-.32.14-.66.2-.98.2Z"
      style={{ fill: '#e6e6e6' }}
    />
    <circle cx="191.96" cy="350.31" r="6.49" style={{ fill: '#e6e6e6' }} />
    <circle cx="325.85" cy="207.42" r="6.49" style={{ fill: '#e6e6e6' }} />
    <path
      d="m351.99,319.73c-.94,0-1.84-.53-2.27-1.44l-10.64-22.76c-.58-1.25-.04-2.74,1.21-3.32,1.25-.58,2.74-.04,3.32,1.21l10.64,22.76c.58,1.25.04,2.74-1.21,3.32-.34.16-.7.24-1.06.24Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m325.89,454.69c-.99,0-1.93-.6-2.32-1.58l-9.3-23.34c-.51-1.28.11-2.74,1.4-3.25,1.28-.51,2.74.11,3.25,1.4l9.3,23.34c.51,1.28-.11,2.74-1.4,3.25-.3.12-.62.18-.92.18Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m262.79,430.45l.39,4.79c.03.4.26.76.61.96l4.17,2.39c.88.5.8,1.8-.14,2.19l-4.43,1.86c-.37.16-.64.48-.73.88l-.99,4.7c-.21.99-1.46,1.32-2.12.55l-3.14-3.64c-.26-.31-.66-.46-1.06-.42l-4.78.52c-1.01.11-1.7-.99-1.18-1.85l2.5-4.11c.21-.34.24-.77.07-1.14l-1.97-4.39c-.42-.93.41-1.92,1.4-1.69l4.68,1.1c.39.09.8-.01,1.1-.28l3.56-3.23c.75-.68,1.96-.2,2.04.81Z"
      style={{ fill: '#e6e6e6' }}
    />
    <path
      d="m317.37,53.4c-5.7-.42-8.41.6-12.42,4.66-.48.49-1.31.11-1.26-.57.42-5.7-.6-8.41-4.66-12.42-.49-.48-.11-1.31.57-1.26,5.7.42,8.41-.6,12.42-4.66.48-.49,1.31-.11,1.26.57-.42,5.7.6,8.41,4.66,12.42.49.48.11,1.31-.57,1.26Z"
      style={{ fill: '#f39122' }}
    />
    <path
      d="m95.59,215.87c-2.92,4.35-3.34,6.97-1.93,12.01.17.61-.51,1.1-1.03.75-4.35-2.92-6.97-3.34-12.01-1.93-.61.17-1.1-.51-.75-1.03,2.92-4.35,3.34-6.97,1.93-12.01-.17-.61.51-1.1,1.03-.75,4.35,2.92,6.97,3.34,12.01,1.93.61-.17,1.1.51.75,1.03Z"
      style={{ fill: '#f39122' }}
    />
    <path
      d="m419.73,419.34c-5.08,1.27-7.15,2.94-9.48,7.63-.28.57-1.11.48-1.26-.14-1.27-5.08-2.94-7.15-7.63-9.48-.57-.28-.48-1.11.14-1.26,5.08-1.27,7.15-2.94,9.48-7.63.28-.57,1.11-.48,1.26.14,1.27,5.08,2.94,7.15,7.63,9.48.57.28.48,1.11-.14,1.26Z"
      style={{ fill: '#f39122' }}
    />
  </svg>
);

export default AccountGirl;
